var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm.$store.state.networks.length === 0
      ? _c(
          "div",
          {
            staticClass: "empty",
            attrs: {
              role: "navigation",
              "aria-label": "Network and Channel list",
            },
          },
          [
            _vm._v("\n\t\tNuk jeni lidhur akoma me serverin, klikoni "),
            _c("b", [_vm._v("LIDHU ME CHAT")]),
            _vm._v(" ose "),
            _c("b", [_vm._v("KiwiIRC")]),
            _vm._v(" per te vazhduar me tej...\n\t"),
          ]
        )
      : _c(
          "div",
          {
            ref: "networklist",
            attrs: {
              role: "navigation",
              "aria-label": "Network and Channel list",
            },
          },
          [
            _c("div", { staticClass: "jump-to-input" }, [
              _c("input", {
                ref: "searchInput",
                staticClass: "search input mousetrap",
                attrs: {
                  placeholder: "Kerkoni per",
                  type: "search",
                  "aria-label": "Search among the channel list",
                  tabindex: "-1",
                },
                domProps: { value: _vm.searchText },
                on: {
                  input: _vm.setSearchText,
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp",
                        ])
                      ) {
                        return null
                      }
                      return _vm.navigateResults($event, -1)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown",
                        ])
                      ) {
                        return null
                      }
                      return _vm.navigateResults($event, 1)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k(
                          $event.keyCode,
                          "page-up",
                          undefined,
                          $event.key,
                          undefined
                        )
                      ) {
                        return null
                      }
                      return _vm.navigateResults($event, -10)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k(
                          $event.keyCode,
                          "page-down",
                          undefined,
                          $event.key,
                          undefined
                        )
                      ) {
                        return null
                      }
                      return _vm.navigateResults($event, 10)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.selectResult.apply(null, arguments)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k(
                          $event.keyCode,
                          "escape",
                          undefined,
                          $event.key,
                          undefined
                        )
                      ) {
                        return null
                      }
                      return _vm.deactivateSearch.apply(null, arguments)
                    },
                  ],
                  focus: _vm.activateSearch,
                },
              }),
            ]),
            _vm.searchText
              ? _c("div", { staticClass: "jump-to-results" }, [
                  _vm.results.length
                    ? _c(
                        "div",
                        _vm._l(_vm.results, function (item) {
                          return _c(
                            "div",
                            {
                              key: item.channel.id,
                              on: {
                                mouseenter: function ($event) {
                                  return _vm.setActiveSearchItem(item.channel)
                                },
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.selectResult.apply(null, arguments)
                                },
                              },
                            },
                            [
                              item.channel.type !== "lobby"
                                ? _c("Channel", {
                                    attrs: {
                                      channel: item.channel,
                                      network: item.network,
                                      active:
                                        item.channel === _vm.activeSearchItem,
                                      "is-filtering": true,
                                    },
                                  })
                                : _c("NetworkLobby", {
                                    attrs: {
                                      channel: item.channel,
                                      network: item.network,
                                      active:
                                        item.channel === _vm.activeSearchItem,
                                      "is-filtering": true,
                                    },
                                  }),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _c("div", { staticClass: "no-results" }, [
                        _vm._v("No results found."),
                      ]),
                ])
              : _c(
                  "Draggable",
                  {
                    staticClass: "networks",
                    attrs: {
                      list: _vm.$store.state.networks,
                      delay: _vm.LONG_TOUCH_DURATION,
                      "delay-on-touch-only": true,
                      "touch-start-threshold": 10,
                      handle: ".channel-list-item[data-type='lobby']",
                      draggable: ".network",
                      "ghost-class": "ui-sortable-ghost",
                      "drag-class": "ui-sortable-dragging",
                      group: "networks",
                    },
                    on: {
                      change: _vm.onNetworkSort,
                      choose: _vm.onDraggableChoose,
                      unchoose: _vm.onDraggableUnchoose,
                    },
                  },
                  _vm._l(_vm.$store.state.networks, function (network) {
                    return _c(
                      "div",
                      {
                        key: network.uuid,
                        staticClass: "network",
                        class: {
                          collapsed: network.isCollapsed,
                          "not-connected": !network.status.connected,
                          "not-secure": !network.status.secure,
                        },
                        attrs: {
                          id: "network-" + network.uuid,
                          role: "region",
                          "aria-live": "polite",
                        },
                        on: {
                          touchstart: _vm.onDraggableTouchStart,
                          touchmove: _vm.onDraggableTouchMove,
                          touchend: _vm.onDraggableTouchEnd,
                          touchcancel: _vm.onDraggableTouchEnd,
                        },
                      },
                      [
                        _c("NetworkLobby", {
                          attrs: {
                            network: network,
                            "is-join-channel-shown": network.isJoinChannelShown,
                            active:
                              _vm.$store.state.activeChannel &&
                              network.channels[0] ===
                                _vm.$store.state.activeChannel.channel,
                          },
                          on: {
                            "toggle-join-channel": function ($event) {
                              network.isJoinChannelShown =
                                !network.isJoinChannelShown
                            },
                          },
                        }),
                        network.isJoinChannelShown
                          ? _c("JoinChannel", {
                              attrs: {
                                network: network,
                                channel: network.channels[0],
                              },
                              on: {
                                "toggle-join-channel": function ($event) {
                                  network.isJoinChannelShown =
                                    !network.isJoinChannelShown
                                },
                              },
                            })
                          : _vm._e(),
                        _c(
                          "Draggable",
                          {
                            staticClass: "channels",
                            attrs: {
                              draggable: ".channel-list-item",
                              "ghost-class": "ui-sortable-ghost",
                              "drag-class": "ui-sortable-dragging",
                              group: network.uuid,
                              list: network.channels,
                              delay: _vm.LONG_TOUCH_DURATION,
                              "delay-on-touch-only": true,
                              "touch-start-threshold": 10,
                            },
                            on: {
                              change: _vm.onChannelSort,
                              choose: _vm.onDraggableChoose,
                              unchoose: _vm.onDraggableUnchoose,
                            },
                          },
                          [
                            _vm._l(network.channels, function (channel, index) {
                              return [
                                index > 0
                                  ? _c("Channel", {
                                      key: channel.id,
                                      attrs: {
                                        channel: channel,
                                        network: network,
                                        active:
                                          _vm.$store.state.activeChannel &&
                                          channel ===
                                            _vm.$store.state.activeChannel
                                              .channel,
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
          ],
          1
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("br"),
      _c("audio", { attrs: { controls: "", autoplay: "true" } }, [
        _c("source", {
          attrs: {
            src: "https://sp14.instainternet.com/8044/shprehu",
            type: "audio/mp3",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }